import { defineNuxtPlugin } from '#app'
import VConsole from 'vconsole'

export default defineNuxtPlugin((nuxtApp) => {
  if (process.env.NODE_ENV === 'development' && process.client && document.documentElement.clientWidth <= 768) {
    const vConsole = new VConsole()
    
    return {
      provide: {
        vconsole: vConsole
      }
    }
  }
});